import { Box, Button, Dialog, DialogContent, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { useEffect } from "react";
import { darkGrayColor, darkGreenColor, grayColor, greenColor, whiteColor, } from "../../constants/constants";
import { addAssignment, cleanList, closeSavePurchaseDialog, fetchGetProjects, fetchProjectServices, fetchRecurringPurchases, fetchSector, fetchSubSector, savesPurchases } from "../../core/state/dialogs/savePurchaseDialogSlice";
import { useAppDispatch, useAppSelector } from "../../core/state/hooks";
import PurchaseRowDialog from "./purchaseRowDialog";

// Columnas específicas para el modal de alta de compras (sin la columna "Acciones")
const dialogColumns = [
    { id: "CheckBox", label: "", minWidth: 45 },
    { id: "Fecha", label: "Fecha", minWidth: 120 },
    { id: "Documento", label: "Documento", minWidth: 170 },
    { id: "Proveedor", label: "Proveedor", minWidth: 300 },
    { id: "RUT", label: "RUT", minWidth: 200 },
    { id: "Rubro", label: "Rubro", minWidth: 200, },
    { id: "CDeRubro", label: "Categoría de Rubro", minWidth: 270, },
    { id: "Concepto", label: "Concepto", minWidth: 250, },
    { id: "Servicio", label: "Servicio", minWidth: 200, },
    { id: "CdeCosto", label: "Centro de Costo", minWidth: 210, },
    { id: "Moneda", label: "Moneda", minWidth: 150, },
    { id: "NOrigen", label: "Neto Origen", minWidth: 170, },
    { id: "Impuestos", label: "Impuestos", minWidth: 150, },
    { id: "Total", label: "Total", minWidth: 150, },
];

export function SavePurchaseDialog() {
    const dispatch = useAppDispatch();
    const { isOpen: dialogIsOpen, purchaseList, projectsList, projectServices, recurringPurchases, sectorList, subSectorList, btnNew, recurringNewPurchases, futureSaveList } = useAppSelector((state) => state.savePurchaseDialog)

    useEffect(() => {
        if (dialogIsOpen) {
            dispatch(fetchSector());
            dispatch(fetchProjectServices());
            dispatch(fetchSubSector());
            dispatch(fetchGetProjects());
            dispatch(fetchRecurringPurchases())
        }
    }, [dialogIsOpen, dispatch]);

    const handleClickSavePurchases = () => {
        dispatch(closeSavePurchaseDialog());
        dispatch(savesPurchases());
        dispatch(cleanList());
    }

    return (
        <Dialog open={dialogIsOpen} onClose={() => { dispatch(closeSavePurchaseDialog()); dispatch(cleanList()); }} maxWidth="lg" >
            <DialogContent sx={{ minWidth: '1200px' }}>
                <DialogContent>
                    <Typography variant="h5" sx={{ color: darkGrayColor }}>Alta de Compras</Typography>
                </DialogContent>
                <DialogContent >
                    <Box sx={{ display: 'flex' }}>
                        <Table sx={{ overflowX: 'scroll', width: '100%' }} stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow >
                                    {recurringPurchases.length > 0 ? dialogColumns.map((column) => (
                                        <TableCell
                                            key={column.id} align="center"
                                            style={{ minWidth: column.minWidth }} sx={{ borderBottom: 1, borderColor: grayColor }}
                                        >
                                            <Typography variant='h6'>{column.label}</Typography>
                                        </TableCell>
                                    )) : <></>
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody >
                                {
                                    recurringPurchases.length > 0 ? recurringPurchases.map((purchase, _index) => {
                                        return (<PurchaseRowDialog projectsList={projectsList} newPurchase={false} services={projectServices} sectores={sectorList} subSectores={subSectorList} index={_index} key={`${purchase.id}`} purchase={purchase} />)
                                    }) : <></>
                                }
                            </TableBody>
                        </Table>
                    </Box>
                </DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'row-reverse', my: 3, alignItems: 'center', backgroundColor: greenColor, maxWidth: '90%', maxHeight: '2px' }}>
                    <Button disabled={btnNew} onClick={() => {
                        dispatch(addAssignment())
                    }} sx={{ backgroundColor: greenColor, color: whiteColor, px: 3, '&:hover': { backgroundColor: darkGreenColor, } }}>
                        Nuevo +
                    </Button>
                </Box>
                <DialogContent>
                    <Box sx={{ display: 'flex' }}>
                        <Table sx={{ overflowX: 'scroll', width: '100%' }} stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow >
                                    {purchaseList.length > 0 ? dialogColumns.map((column) => (
                                        <TableCell
                                            key={column.id} align="center"
                                            style={{ minWidth: column.minWidth }} sx={{ borderBottom: 1, borderColor: grayColor }}
                                        >
                                            <Typography variant='h6'>{column.label}</Typography>
                                        </TableCell>
                                    )) : <></>
                                    }
                                </TableRow>
                            </TableHead>
                            <TableBody >
                                {
                                    purchaseList.length > 0 ? purchaseList.map((n, _index) => {
                                        return (
                                            <PurchaseRowDialog projectsList={projectsList} sectores={sectorList} subSectores={subSectorList} index={_index} newPurchase={true} purchase={undefined} services={projectServices} key={`${n.key}`} />
                                        )
                                    }) : <></>
                                }
                            </TableBody>
                        </Table>
                    </Box>
                </DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'row-reverse', mt: 2, maxWidth: '90%' }}>
                    <Button onClick={handleClickSavePurchases} sx={{ backgroundColor: greenColor, color: whiteColor, px: 3, '&:hover': { backgroundColor: darkGreenColor, } }}
                        disabled={recurringNewPurchases.length > 0 || futureSaveList.length > 0 ? btnNew : true}
                    >
                        Guardar
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    )
}